import HeroSection from "@/components/landing/HeroSection";
import PainPointsSection from "@/components/landing/PainPointsSection";
import TimeSavingsSection from "@/components/landing/TimeSavingsSection";
import DemoToolSection from "@/components/landing/DemoToolSection";
import AppScreenshotsSection from "@/components/landing/AppScreenshotsSection";
import FreeToolsSection from "@/components/landing/FreeToolsSection";
import PremiumToolsSection from "@/components/landing/PremiumToolsSection";
import NewToolsShowcaseSection from "@/components/landing/NewToolsShowcaseSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import PlayStoreLaunchSection from "@/components/landing/PlayStoreLaunchSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import InstallGuideSection from "@/components/landing/InstallGuideSection";
import ShareSection from "@/components/landing/ShareSection";
import CTASection from "@/components/landing/CTASection";
import FAQSection from "@/components/landing/FAQSection";
import LeadCaptureForm from "@/components/landing/LeadCaptureForm";
import ContactSection from "@/components/landing/ContactSection";
import FooterSection from "@/components/landing/FooterSection";

export default function LandingPage() {
  const downloadLink = "https://play.google.com/store/apps/details?id=com.wnapp.id1781430851106&hl=en_IN";

  return (
    <div className="scroll-smooth min-h-screen bg-white">
      <HeroSection downloadLink={downloadLink} />
      <PainPointsSection />
      <TimeSavingsSection downloadLink={downloadLink} />
      <DemoToolSection />
      <AppScreenshotsSection downloadLink={downloadLink} />
      <FreeToolsSection />
      <PremiumToolsSection downloadLink={downloadLink} />
      <NewToolsShowcaseSection downloadLink={downloadLink} />
      <SocialProofSection />
      <TestimonialsSection />
      <PlayStoreLaunchSection downloadLink={downloadLink} />
      <HowItWorksSection />
      <InstallGuideSection downloadLink={downloadLink} />
      <ShareSection />
      <CTASection downloadLink={downloadLink} />
      <FAQSection />
      <LeadCaptureForm />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
